import { create } from "zustand";

export interface DooryCustomKnowledgeModalState {
  isOpen: boolean;
  companyId: number | null;
  messageId: string | null;
  questionText: string;
  answerText: string | null;
  isEditMode: boolean;
  isAnonymousMessage: boolean;
  onAfterSave: (() => void) | null;
  open(
    companyId: number,
    messageId: string,
    questionText: string,
    answerText: string | null,
    isEditMode: boolean,
    isAnonymousMessage: boolean,
    onAfterSave?: () => void,
  ): void;
  close(): void;
}

export const useDooryCustomKnowledgeModalStore =
  create<DooryCustomKnowledgeModalState>((set) => {
    return {
      isOpen: false,
      companyId: null,
      messageId: null,
      questionText: "",
      answerText: null,
      isEditMode: false,
      isAnonymousMessage: false,
      onAfterSave: null,
      open: (
        companyId: number,
        messageId: string,
        questionText: string,
        answerText: string | null,
        isEditMode: boolean,
        isAnonymousMessage: boolean = false,
        onAfterSave?: () => void,
      ) =>
        set(() => ({
          isOpen: true,
          messageId,
          questionText,
          answerText,
          isEditMode,
          companyId,
          isAnonymousMessage,
          onAfterSave: onAfterSave ?? null,
        })),

      close: () =>
        set(() => ({
          isOpen: false,
          messageId: null,
          questionText: "",
          answerText: null,
          companyId: null,
          isEditMode: false,
          isAnonymousMessage: false,
          onAfterSave: null,
        })),
    };
  });
